export enum enumMarginType {
  FIXED,
  PERCENTAGE,
}
